import { Loader } from 'lucide-react'

export const Loading = () => {
    return (
        <div className="flex justify-center items-center h-full text-[--primary-500]">
            <Loader size={48} className="animate-spin duration-500" />
        </div>
    )
}
